function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { max, tau } from "./math.js";
function range(i, j) {
  return Array.from({
    length: j - i
  }, function (_, k) {
    return i + k;
  });
}
function compareValue(compare) {
  return function (a, b) {
    return compare(a.source.value + a.target.value, b.source.value + b.target.value);
  };
}
export default function () {
  return chord(false, false);
}
export function chordTranspose() {
  return chord(false, true);
}
export function chordDirected() {
  return chord(true, false);
}
function chord(directed, transpose) {
  var padAngle = 0,
    sortGroups = null,
    sortSubgroups = null,
    sortChords = null;
  function chord(matrix) {
    var n = matrix.length,
      groupSums = new Array(n),
      groupIndex = range(0, n),
      chords = new Array(n * n),
      groups = new Array(n),
      k = 0,
      dx;
    matrix = Float64Array.from({
      length: n * n
    }, transpose ? function (_, i) {
      return matrix[i % n][i / n | 0];
    } : function (_, i) {
      return matrix[i / n | 0][i % n];
    });

    // Compute the scaling factor from value to angle in [0, 2pi].
    for (var i = 0; i < n; ++i) {
      var x = 0;
      for (var j = 0; j < n; ++j) x += matrix[i * n + j] + directed * matrix[j * n + i];
      k += groupSums[i] = x;
    }
    k = max(0, tau - padAngle * n) / k;
    dx = k ? padAngle : tau / n;

    // Compute the angles for each group and constituent chord.
    {
      var _x = 0;
      if (sortGroups) groupIndex.sort(function (a, b) {
        return sortGroups(groupSums[a], groupSums[b]);
      });
      var _iterator = _createForOfIteratorHelper(groupIndex),
        _step;
      try {
        var _loop = function _loop() {
          var i = _step.value;
          var x0 = _x;
          if (directed) {
            var subgroupIndex = range(~n + 1, n).filter(function (j) {
              return j < 0 ? matrix[~j * n + i] : matrix[i * n + j];
            });
            if (sortSubgroups) subgroupIndex.sort(function (a, b) {
              return sortSubgroups(a < 0 ? -matrix[~a * n + i] : matrix[i * n + a], b < 0 ? -matrix[~b * n + i] : matrix[i * n + b]);
            });
            var _iterator2 = _createForOfIteratorHelper(subgroupIndex),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _j = _step2.value;
                if (_j < 0) {
                  var _chord = chords[~_j * n + i] || (chords[~_j * n + i] = {
                    source: null,
                    target: null
                  });
                  _chord.target = {
                    index: i,
                    startAngle: _x,
                    endAngle: _x += matrix[~_j * n + i] * k,
                    value: matrix[~_j * n + i]
                  };
                } else {
                  var _chord2 = chords[i * n + _j] || (chords[i * n + _j] = {
                    source: null,
                    target: null
                  });
                  _chord2.source = {
                    index: i,
                    startAngle: _x,
                    endAngle: _x += matrix[i * n + _j] * k,
                    value: matrix[i * n + _j]
                  };
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            groups[i] = {
              index: i,
              startAngle: x0,
              endAngle: _x,
              value: groupSums[i]
            };
          } else {
            var _subgroupIndex = range(0, n).filter(function (j) {
              return matrix[i * n + j] || matrix[j * n + i];
            });
            if (sortSubgroups) _subgroupIndex.sort(function (a, b) {
              return sortSubgroups(matrix[i * n + a], matrix[i * n + b]);
            });
            var _iterator3 = _createForOfIteratorHelper(_subgroupIndex),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _j2 = _step3.value;
                var _chord3 = void 0;
                if (i < _j2) {
                  _chord3 = chords[i * n + _j2] || (chords[i * n + _j2] = {
                    source: null,
                    target: null
                  });
                  _chord3.source = {
                    index: i,
                    startAngle: _x,
                    endAngle: _x += matrix[i * n + _j2] * k,
                    value: matrix[i * n + _j2]
                  };
                } else {
                  _chord3 = chords[_j2 * n + i] || (chords[_j2 * n + i] = {
                    source: null,
                    target: null
                  });
                  _chord3.target = {
                    index: i,
                    startAngle: _x,
                    endAngle: _x += matrix[i * n + _j2] * k,
                    value: matrix[i * n + _j2]
                  };
                  if (i === _j2) _chord3.source = _chord3.target;
                }
                if (_chord3.source && _chord3.target && _chord3.source.value < _chord3.target.value) {
                  var source = _chord3.source;
                  _chord3.source = _chord3.target;
                  _chord3.target = source;
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
            groups[i] = {
              index: i,
              startAngle: x0,
              endAngle: _x,
              value: groupSums[i]
            };
          }
          _x += dx;
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    // Remove empty chords.
    chords = Object.values(chords);
    chords.groups = groups;
    return sortChords ? chords.sort(sortChords) : chords;
  }
  chord.padAngle = function (_) {
    return arguments.length ? (padAngle = max(0, _), chord) : padAngle;
  };
  chord.sortGroups = function (_) {
    return arguments.length ? (sortGroups = _, chord) : sortGroups;
  };
  chord.sortSubgroups = function (_) {
    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
  };
  chord.sortChords = function (_) {
    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
  };
  return chord;
}